import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { pdfjs, Page } from "react-pdf";
import styles from "./styles";
import { Document } from "react-pdf/dist/entry.webpack";
// import workerSrc from "pdfjs-dist/build/pdf.worker.js";

import {
	Modal,
	withStyles
} from "@material-ui/core";
import Toolbar from "./Toolbar";

// pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class Viewer___ extends React.Component {

	state = {
		numPages: 0,
		pageNumber: 1,
		scale: 1
	}

	handleZoomIn = () => {
		this.setState((prevState) => ({
			...prevState,
			scale: prevState.scale * 1.2
		}));
	}

	handleZoomOut = () => {
		this.setState((prevState) => ({
			...prevState,
			scale: prevState.scale / 1.2
		}));
	}

	handleDocumentLoadSuccess = ({ numPages }) => {
		this.setState({ numPages });
	}

	handleNextPage = () => {
		this.setState((prevState) => ({
			...prevState,
			numPages: prevState.pageNumber++
		}));
		console.log(this.state.pageNumber)
	}

	handlePrevPage = () => {
		this.setState((prevState) => ({
			...prevState,
			numPages: prevState.pageNumber--
		}));
	}

	render() {
		const { pageNumber, numPages, scale } = this.state;
		const { classes, toggleViewer, viewerOpened, file } = this.props;

		return (
			<Modal
				className={classNames(classes.root)}
				onClose={toggleViewer}
				open={viewerOpened}
			>
				<div
					className={classNames(classes.wrapper)}
				>
					<Document
						className={classNames(classes.document)}
						file={file}
						onLoadSuccess={this.handleDocumentLoadSuccess}
					>
						<Page
							scale={scale}
							className={classNames(classes.page)}
							pageNumber={pageNumber}
						/>
					</Document>
					<Toolbar
						onZoomIn={this.handleZoomIn}
						onZoomOut={this.handleZoomOut}
						onPageNext={this.handleNextPage}
						onPagePrev={this.handlePrevPage}
						pageNumber={pageNumber}
						numPages={numPages}
					/>
				</div>
			</Modal>
		);
	}

}

function Viewer({ classes, toggleViewer, viewerOpened, file }) {

	const [numPages, setNumPages] = useState(null);
	const [scale, setScale] = useState(0.8 / 1.2);

	useEffect(() => {

	}, [numPages])

	const handleZoomIn = () => {
		setScale(scale * 1.2)
	}

	const handleZoomOut = () => {
		setScale(scale / 1.2)
	}

	const handleDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	}

	return (

		<Modal
			className={classNames(classes.root)}
			onClose={toggleViewer}
			open={viewerOpened}
		>
			<div
				className={classNames(classes.wrapper)}
			>
				<Document
					className={classNames(classes.document)}
					file={file}
					onLoadSuccess={handleDocumentLoadSuccess}
				>
					{[...Array(numPages)].map((x, i) =>
    					<Page
						pageNumber={i}
						scale={scale}
						className={classNames(classes.page)}
					/>
  					)}
					
					
				</Document>
				<Toolbar
					onZoomIn={handleZoomIn}
					onZoomOut={handleZoomOut}
					onClose={toggleViewer}
				/>
			</div>
		</Modal>
	)
}


Viewer.propTypes = {
	classes: PropTypes.object.isRequired,
	file: PropTypes.string.isRequired,
	toggleViewer: PropTypes.func.isRequired,
	viewerOpened: PropTypes.bool.isRequired
};

export default withStyles(styles)(Viewer);
